import { NgModule } from '@angular/core';
import { GroupByPipe } from './group-by.pipe';
import { MaxPipe } from './max.pipe';
import { MeanPipe } from './mean.pipe';
import { MinPipe } from './min.pipe';
import { SumPipe } from './sum.pipe';
var NgAggregatePipesModule = (function () {
    function NgAggregatePipesModule() {
    }
    return NgAggregatePipesModule;
}());
export { NgAggregatePipesModule };
NgAggregatePipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    GroupByPipe,
                    MaxPipe,
                    MeanPipe,
                    MinPipe,
                    SumPipe
                ],
                exports: [
                    GroupByPipe,
                    MaxPipe,
                    MeanPipe,
                    MinPipe,
                    SumPipe
                ]
            },] },
];
/** @nocollapse */
NgAggregatePipesModule.ctorParameters = function () { return []; };
export * from './group-by.pipe';
export * from './max.pipe';
export * from './mean.pipe';
export * from './min.pipe';
export * from './sum.pipe';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/aggregate/index.js
// module id = 222
// module chunks = 103